import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../redux/slices/modals';
import { selectPrivyToken } from '../redux/slices/auth';
import { useGetCurrentUserProfileQuery } from '../redux/api/authorized/auth';
import { useFlag } from '@unleash/proxy-client-react';

const useApplePay = () => {
  const dispatch = useDispatch();
  const privyToken = useSelector(selectPrivyToken);
  const enableApplePay = useFlag('enableApplePay');
  const { data: currentUser } = useGetCurrentUserProfileQuery(undefined, {
    skip: !privyToken,
  });

  const applePayEnabled =
    Capacitor.isNativePlatform() &&
    Capacitor.isPluginAvailable('HiddenWebview') &&
    Capacitor.getPlatform() === 'ios' &&
    enableApplePay;

  const handleApplePay = async () => {
    dispatch(
      openModal({
        name: 'amountSelector',
        props: {
          minAmount: 2,
          onContinue: (amount) => {
            const openApplePay = () => {
              dispatch(
                openModal({
                  name: 'applePay',
                  props: { amount },
                }),
              );
            };
            if (currentUser?.phoneNumber) {
              openApplePay();
            } else {
              dispatch(
                openModal({
                  name: 'verifyPhoneNumber',
                  props: { onContinue: openApplePay },
                }),
              );
            }
          },
        },
      }),
    );
  };

  return { handleApplePay, applePayEnabled };
};

export default useApplePay;
